export default "__VITE_ASSET__ndJSFiPC__";